module.exports = __webpack_public_path__ + "static/app-3f1d9044b29835c09b7292f7880a034b.png";